export default class OptimizedFlowOutputData {
    constructor(data) {
        this.flowName = data.flowName;
        this.caseName = data.caseName;
    }
}